import { BigNumber } from "@ethersproject/bignumber";
import { fromWei } from "web3-utils";

const _dec = (value: number, decimals: number) => {
  // Clamp decimals to valid range for maximumFractionDigits (0-100)
  const safeDecimals = Math.max(0, Math.min(100, Math.floor(decimals) || 0));
  return value.toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: safeDecimals,
  });
};

type Value = BigNumber | number | bigint | string;

function formatValue(value: BigNumber, format?: true): string;
function formatValue(value: BigNumber, format?: false): number;
function formatValue(value: BigNumber, currency?: string): string;

function formatValue(value: number, format?: true): string;
function formatValue(value: number, format?: false): number;

function formatValue(value: string, format?: true): string;
function formatValue(value: string, format?: false): number;

function formatValue(value: bigint, format?: true): string;
function formatValue(value: bigint, format?: false): number;

function formatValue(value: Value, format?: true, decimals?: number): string;
function formatValue(value: Value, format?: false, decimals?: number): number;

function formatValue(value: Value, format?: boolean, decimals?: number, currency?: string): string;

function formatValue(value: Value, formatOrCurrency?: boolean | string, decimals = 2, currency = "") {
  const currencyText = (val?: string) => (val ? " " + val : "");

  if (BigNumber.isBigNumber(value)) {
    const ether = fromWei(value.toString(), "ether");
    const GWei = fromWei(value.toString(), "Gwei");

    if (typeof formatOrCurrency === "boolean") {
      return formatOrCurrency ? `${GWei} Gwei (${ether} ETH)` : Number(Number(ether).toFixed(decimals));
    } else {
      return formatOrCurrency === "ETH" ? `${ether} ETH` : `${GWei} Gwei (${ether} ETH)`;
    }
  } else if (typeof value === "string") {
    const _val = fromWei(value, "ether");
    return typeof formatOrCurrency === "boolean"
      ? formatOrCurrency
        ? _dec(Number(_val), decimals) + currencyText(currency)
        : Number(_val)
      : _dec(Number(_val), decimals) + currencyText(formatOrCurrency);
  } else if (typeof value === "bigint") {
    const str = value.toString();
    const _val = str.length > 10 ? fromWei(value.toString(), "ether") : str;
    return typeof formatOrCurrency === "boolean"
      ? formatOrCurrency
        ? _dec(Number(_val), decimals) + currencyText(currency)
        : Number(_val)
      : _dec(Number(_val), decimals) + currencyText(formatOrCurrency);
  } else {
    return typeof formatOrCurrency === "boolean"
      ? formatOrCurrency
        ? _dec(value, decimals) + currencyText(currency)
        : value
      : _dec(value, decimals) + currencyText(formatOrCurrency);
  }
}

const toParcels = (input: string) => {
  const match = /^([\d\.]+)\s*,\s*([\w\s]+)$/.exec(input.replace(/\s*,\s*/, ","));

  if (!match) {
    return "";
  }

  const value = parseFloat(match[1]);
  const unit = match[2].toLowerCase().trim();

  if (isNaN(value)) {
    return "";
  }

  // Direct lookup in the static conversion factor object
  const factor = {
    ha: 10000,
    hectares: 10000,
    acre: 4046.86,
    acres: 4046.86,
    perch: 25.2929,
    sqft: 0.092903,
    sqm: 1,
    "square meter": 1,
    "square foot": 0.092903,
    "square yard": 0.836127,
    "square mile": 2589988.11,
    "square kilometer": 1000000,
    "square inch": 0.00064516,
    are: 100,
    centiare: 1,
    rood: 1011.71,
    "square rod": 25.2929,
  }[unit];

  if (factor === undefined) {
    return "";
  }

  return `${((value * factor) / 100).toFixed(2)} parcels`;
};

const toHectares = (input: string) => {
  const parcels = toParcels(input);
  const number = parcels.split(" ")[0];
  const hectares = Number(number) / 100;
  const formatted = hectares % 1 === 0 ? hectares.toFixed(0) : hectares.toFixed(2);
  return `${formatted} hectares`;
};

const toHectareYears = (input: string, period: number) => {
  const hectares = toHectares(input);
  const number = hectares.split(" ")[0];
  const hectareYears = Number(number) * period; // Assuming 1 hectare = 10 hectare-years
  const formatted = hectareYears % 1 === 0 ? hectareYears.toFixed(0) : hectareYears.toFixed(2);
  return `${formatted} HA-YEARS`;
};

export { formatValue, toParcels, toHectares, toHectareYears };

// function formatValue(value: Value, formatOrCurrency?: boolean | string, decimals = 0, currency = "") {
//   if (BigNumber.isBigNumber(value)) {
//     if (typeof formatOrCurrency === "boolean") {
//       if (formatOrCurrency) {
//         const ether = fromWei(value._hex, "ether");
//         const GWei = fromWei(value._hex, "Gwei");
//         return `${GWei} Gwei (${ether} ETH)`;
//       } else {
//         return Number(value.toNumber().toFixed(decimals));
//       }
//     } else {
//       const ether = fromWei(value._hex, "ether");
//       const GWei = fromWei(value._hex, "Gwei");
//       if (formatOrCurrency === "ETH") {
//         return ether + " ETH";
//       } else {
//         return `${GWei} Gwei (${ether} ETH)`;
//       }
//     }
//   } else if (typeof value === "string") {
//     const _val = fromWei(value, "ether");
//     if (typeof formatOrCurrency === "boolean") {
//       if (formatOrCurrency) {
//         return _dec(Number(_val), decimals) + currency;
//       } else {
//         return Number(_val);
//       }
//     } else {
//       return _dec(Number(_val), decimals) + currency;
//     }
//   } else if (typeof value === "bigint") {
//     const str = value.toString();
//     let _val = "";
//     if (str.length > 10) {
//       _val = fromWei(toHex(value), "ether");
//     } else {
//       _val = str;
//     }
//     if (typeof formatOrCurrency === "boolean") {
//       if (formatOrCurrency) {
//         return _dec(Number(_val), decimals) + currency;
//       } else {
//         return Number(_val);
//       }
//     } else {
//       return Number(_val);
//     }
//   } else {
//     if (typeof formatOrCurrency === "boolean") {
//       if (formatOrCurrency) {
//         return _dec(value, decimals);
//       } else {
//         return value;
//       }
//     } else {
//       return _dec(value, decimals) + currency;
//     }
//   }
// }
